import {ComponentData} from "../../engine/tools/EntityManager";


export class AnimationSoundPlayer implements ComponentData {

    lastAnimation: string
    lastFrame: number

    constructor(options?: Partial<AnimationSoundPlayer>) {
        Object.assign(this, options)
    }
}